<template>
  <div>
    <ul class="cos-tab-form-check">
      <li><label class="form-ctrl-label">
          <input type="checkbox" class="tc-15-checkbox" v-model="UploadDoubleCheckEdit"
            :value="true">{{$t('cos.upload_double_check')}}<br />
          <span class="text-weak"
            style="display:inline-block;margin:6px 0 0 20px;">{{$t('cos.upload_double_check_tips')}}</span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
import { tips } from '@/scripts/tools/utils';
import storage, { Storage } from '@/scripts/tools/storage';

const storagePrefix = 'upload.';

export default {
  props: {
    disabledBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const data = {
      keyList: [
        'UploadDoubleCheck',
      ],
    };
    data.keyList.forEach(key => {
      data[key] = storage.get(storagePrefix + key);
      data[`${key}Edit`] = data[key];
      data[`${key}Error`] = '';
    });
    return {
      ...data,
      isAllow: true,
    };
  },
  computed: {
    isSame() {
      return this.UploadDoubleCheckEdit === this.UploadDoubleCheck;
    },
    disabledSave() {
      return this.isSame || !this.isAllow;
    },
  },
  watch: {
    // 触发禁用保存按钮
    disabledSave() {
      this.$emit('update:disabledBtn', this.disabledSave);
    },
  },
  methods: {
    resetDefaultValue() {
      this.keyList.forEach(key => {
        this[`${key}Edit`] = Storage.getDefaultValue(storagePrefix + key);
      });
    },
    getEditVal(key) {
      return Storage.transferValType(storagePrefix + key, this[`${key}Edit`]);
    },
    save() {
      if (this.disabledSave) return;
      this.keyList.forEach(key => {
        const editVal = this.getEditVal(key);
        if (this[key] !== editVal) {
          storage.add(storagePrefix + key, editVal);
          this[key] = editVal;
        }
      });
      tips.success(
        window.lang.t('core.success', { msg: window.lang.t('core.save') }),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.traffic-limit {
  padding-right: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .tc-15-input-text {
    width: 85%;
  }

  .traffic-limit-unit {
    font-size: 14px;
  }
}

.text-weak {
  display: inline-block;
  margin: 6px 0 0 0;
  font-size: 12px;
}

.error-text {
  color: #e1504a !important;
}

.tip-icon {
  width: 14px;
  height: 14px;
}
</style>
